<!-- report_post_list_tiktok.vue -->
<template>
  <reportPostList
      ref="inner"
      :report_id="report_id"
      :sns_type="'tiktok'"
      :postValueComponent="reportPostValueTiktok"
      v-bind="$attrs"
      v-on="$listeners"
  />
</template>

<script>
import reportPostList from "./report_post_list.vue";
import reportPostValueTiktok from "./report_post_value_tiktok.vue";

export default {
  name: "reportPostListTiktok",
  props: ["report_id"],
  components: { reportPostList },
  data() {
    return { reportPostValueTiktok };
  },
  methods: {
    reload() {
      this.$refs.inner?.reload?.();
    },
  },
};
</script>
